// import Vue from 'vue'
// import VueRouter from 'vue-router'
import { createRouter, createWebHistory  } from 'vue-router'
// import Home from '../views/Home.vue'



//this does https://alligator.io/vuejs/creating-custom-plugins/ , i.e. variables starting with $ exist now in every instance
// Vue.use(VueRouter);
// now done in main.js



const routes = [
  //begin: Internet
  {
    path: '/', 
    // name: 'home',
    component: () => import('@/views/Login.vue')
  },
  //end: Internet
  //begin: Intranet
  {
    path: '/intra/owner-list',
    component: () => import('@/views/intra/OwnerList.vue')
  }, {
    path: '/intra/device-list/:ownerId',
    component: () => import('@/views/intra/DeviceList.vue')
  }, {
    path: '/intra/command-list-pending/:ownerId/:deviceId',
    component: () => import('@/views/intra/CommandListPending.vue')
  }, {
    path: '/intra/command-list-history/:ownerId/:deviceId',
    component: () => import('@/views/intra/CommandListHistory.vue')
  }, {
    path: '/intra/phone-list/:ownerId/:deviceId',
    component: () => import('@/views/intra/SentPhoneList.vue')
  }, {
    path: '/intra/user-list',
    component: () => import('@/views/intra/UserList.vue')
  }, {
    path: '/intra/letter-list/:ownerId/:deviceId',
    component: () => import('@/views/intra/SentLetterList.vue')
  }, {
    path: '/intra/command-failed-list',
    component: () => import('@/views/intra/CommandFailedList.vue')
  }, {
    path: '/intra/config',
    component: () => import('@/views/intra/Config.vue')
  }, {
    path: '/intra/i18n',
    component: () => import('@/views/intra/I18n.vue')
  }, {
    path: '/intra/whitelist',
    component: () => import('@/views/intra/Whitelist.vue')
  }, {
    path: '/intra/invoice-list/:ownerId',
    component: () => import('@/views/intra/SentInvoiceList.vue')
  }, {
    path: '/intra/owner-edit/:ownerId',
    component: () => import('@/views/intra/OwnerEdit.vue')
  }, {
    path: '/intra/distributor-list',
    component: () => import('@/views/intra/DistributorList.vue')
  }, {
    path: '/intra/distributor-edit/:diId',
    component: () => import('@/views/intra/DistributorEdit.vue')
  }, {
    path: '/intra/device-edit/:ownerId/:deviceId',
    component: () => import('@/views/intra/DeviceEdit.vue')
  }, {
    path: '/intra/install-summary/:ownerId',
    component: () => import('@/views/intra/InstallSummary.vue')
  }, {
    path: '/intra/versions',
    component: () => import('@/views/intra/Versions.vue')
  }, {
    path: '/intra/sent-invoice-list-2021/:diId',
    component: () => import('@/views/intra/SentInvoiceList2021.vue')
  }, {
    path: '/intra/mail-list/:ownerId/:deviceId',
    component: () => import('@/views/intra/SentMailList.vue')
  }, {
    path: '/intra/device-list-all',
    component: () => import('@/views/intra/DeviceListAll.vue')
  }, {
    path: '/intra/software/manage',
    component: () => import('@/views/intra/SoftwareManage.vue')
  }, {
    path: '/intra/software/manage/edit/:softId',
    component: () => import('@/views/intra/SoftwareEdit.vue')
  }, {
    path: '/intra/software/manage/notify',
    component: () => import('@/views/intra/SoftwareNotify.vue')
  }, {
    path: '/intra/software/manage/download',
    component: () => import('@/views/intra/SoftwareDownload.vue')
  }, {
    path: '/intra/backup-controller/:ownerId/:deviceId',
    component: () => import('@/views/intra/BackupController.vue')
  }, {
    path: '/intra/backup-config/:ownerId/:deviceId',
    component: () => import('@/views/intra/BackupConfig.vue')
  }, {
    path: '/intra/wireguard-config/:diId',
    component: () => import('@/views/intra/WireguardConfig.vue')
  }, {
    path: '/intra/bundle',
    component: () => import('@/views/intra/Bundle.vue')
  }, {
    path: '/intra/bundle-edit/:fcbId',
    component: () => import('@/views/intra/BundleEdit.vue')
  }, {
    path: '/intra/unbilled-list/:tab',
    component: () => import('@/views/intra/UnbilledList.vue')
  }, {
    path: '/intra/software/license',
    component: () => import('@/views/intra/SoftwareLicenseList.vue')
  }, {
    path: '/intra/software/license/edit/:licenseId',
    component: () => import('@/views/intra/SoftwareLicenseEdit.vue')
  }, /*{
    path: '/intra/app-switch',
    component: () => import('@/views/intra/AppSwitch.vue')
  }, */{
    path: '/intra/unbilled-list',
    redirect: '/intra/unbilled-list/phone',
  },
  //end: Intranet

]

// const router = new VueRouter({
const router = createRouter({
  // honor https://developers.google.com/search/docs/guides/javascript-seo-basics
  // mode: 'history',
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  // base: '/', - nicht gesund, siehe https://cli.vuejs.org/guide/html-and-static-assets.html#the-public-folder
})

export default router
